import ParcelRateCell from './ParcelRateCell';

const DoubleParcelRatesCell = ({
  name,
  field,
  name2,
  field2,
  type = 'text',
  data,
  setData,
  maxLength = 100,
  customClassName = '',
  index,
  recentlyUpdatedData,
  originalData,
  nullable = false,
  isNew = false,
}) => {
  return (
    <>
      <div>
        <div className="font-bold">{name}:</div>
        {ParcelRateCell({
          name,
          field,
          type,
          data,
          setData,
          originalData,
          maxLength,
          customClassName,
          index,
          recentlyUpdatedData,
          nullable,
          isNew,
        })}
      </div>
      <div>
        <div className="font-bold">{name2}:</div>
        {ParcelRateCell({
          name: name2,
          field: field2,
          type,
          data,
          setData,
          originalData,
          maxLength,
          customClassName,
          index,
          recentlyUpdatedData,
          nullable,
          isNew,
        })}
      </div>
    </>
  );
};

export default DoubleParcelRatesCell;
